export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));


  if (user && user.token) {
    // Ensure token has Bearer prefix
    const token = user.token.startsWith('Bearer ')
      ? user.token
      : `Bearer ${user.token}`;
    return { Authorization: token };
  } else {
    return {};
  }
}
